import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./NmefSpinner.scss";
import useStyle from "./UseStyles";
const NmefSpinner = () => {
    const classes = useStyle();
    return (
        <div className={classes.nmef_spinner_container}>
            <CircularProgress size={35} color="secondary" />
            <span className={classes.sr_only}>Loading...</span>
        </div>
    );
};

export default NmefSpinner;
